import React from 'react'
import styled from 'styled-components'
import Button from 'li-components/lib/next/Button'
import OutsideClick from 'li-components/lib/OutsideClick'
import vars from 'li-components/lib/styles'

export const Sidebar = styled(OutsideClick)`
  position: absolute;
  top: 0;
  right: ${p => (p.open ? 0 : '-350px')};
  z-index: 3;
  display: flex;
  flex-direction: column;
  width: ${p => (p.open ? '350px' : 0)};
  height: ${p => (p.open ? '100vh' : 0)};
  min-height: 400px;
  visibility: ${p => (p.open ? 'visible' : 'hidden')};
  background-color: ${vars.white};
  border-left: 1px solid ${vars.grayLight};
  transition: right 0.25s;
  font-size: 1em;

  h2 {
    font-size: 1.5em;
  }

  h4 {
    color: ${vars.textColor};
    margin-top: 0;
    margin-bottom: 0.75rem;
    font-size: 1em;
  }
`

const getSidebarBackgroundColor = p =>
  p.impersonating ? vars.labelInsightPurple : vars.grayLightest

const getSidebarTextColor = p => (p.impersonating ? vars.white : vars.textColor)

export const SidebarHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 0;
  flex-shrink: 0;
  height: 70px;
  padding: 0 2rem;
  color: ${getSidebarTextColor};
  background-color: ${getSidebarBackgroundColor};
  border-left: 1px solid ${getSidebarBackgroundColor};
  border-bottom: 1px solid ${vars.grayLight};
  font-weight: 600;

  h2 {
    display: flex;
    align-items: center;
    margin: 0;
    font-weight: 600;
    color: ${vars.textColor};
  }

  .SvgIcon svg {
    fill: ${getSidebarTextColor};
    width: 1.5em;
    height: 1.5em;
    cursor: pointer;
  }
`

export const SidebarHeaderDrilled = SidebarHeader.extend`
  justify-content: left;
`

export const SidebarCloseButton = styled.span`
  font-size: 3em;
  cursor: pointer;
`

export const SidebarMain = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
`

export const SidebarMainHeaderSection = styled.section`
  flex-grow: 0;
  flex-shrink: 0;
  padding: 2rem;
  border-bottom: 2px solid ${vars.cardBorderColor};
`

export const SidebarMainMiddleSection = styled.section`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  overflow: auto;
`

export const SidebarMainBottomSection = styled.section`
  flex-grow: 0;
  flex-shrink: 0;
`

export const SidebarFooter = styled.footer`
  flex-grow: 0;
  flex-shrink: 0;
  padding: 2rem;
  border-top: 2px solid ${vars.cardBorderColor};
`

export const SidebarMainBottomMenuItem = styled.li`
  border-top: 2px solid ${vars.cardBorderColor};

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    color: ${vars.textColor};
    text-decoration: none;
  }

  h4 {
    margin: 0;
  }

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  svg {
    width: 1.5em;
    height: 1.5em;
    fill: ${vars.textColor};
  }
`

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const SidebarListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 2rem;
  color: ${vars.textColor};
  text-decoration: none;
  border-bottom: 2px solid ${vars.grayLighter};
  cursor: pointer;

  > a {
    display: inline-block;
    width: 100%;
    color: ${vars.textColor} !important;
    text-decoration: none;
  }

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  svg {
    width: 0.75em;
    height: 0.75em;
    fill: ${vars.textColor};
  }
`

export const FormGroup = styled.div`
  margin-bottom: 2rem;

  > label {
    display: block;
    margin-bottom: 0.75rem;
    font-weight: 400;
  }

  > button {
    display: block;
    margin: 0 auto;
    border-radius: 2px;
  }
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 400;
  color: ${vars.gray};
`

export const Input = styled.input`
  width: 100%;
  height: 4.5rem;
  padding: 1rem 1.5rem;
  font-size: 16px;
  line-height: 1.333333;
  border: 1px solid ${vars.grayLight};
  border-radius: ${vars.inputBorderRadius};
`

export const HelpBlock = styled.small`
  margin: 0.5rem 0;
  color: ${vars.brandDanger};
`

export const PrimaryLinkStyle = `
  color: ${vars.brandPrimary};

  &:hover {
    color: ${vars.btnPrimaryHover};
  }
`

const Submit = Button.withComponent('input').extend`
  display: block;
  width: auto;
  margin: 0 auto;
`

export const SubmitButton = props => (
  <Submit type="submit" kind="primary" value="Submit" {...props} />
)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/styled.js